import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="game-title">🌱 Sprout & Bloom</h1>
          <p className="tagline">Grow your greenhouse empire, one seed at a time</p>
          <button className="play-button" onClick={() => navigate('/game')}>
            🌿 Play Now
          </button>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <h2>About the Game</h2>
        <p className="description">
          Sprout & Bloom is a relaxing idle farming game where you build and automate your greenhouse empire. 
          Plant seeds, watch them grow, and expand your operation across multiple greenhouses. 
          Overcome seasonal challenges, unlock rare plant varieties, and become the ultimate greenhouse master!
        </p>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2>Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🌱</div>
            <h3>Plant & Grow</h3>
            <p>Plant diverse seeds and watch them flourish through their growth stages</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">⚙️</div>
            <h3>Automate Everything</h3>
            <p>Upgrade your greenhouses with drip irrigation, climate control, and advanced HVAC systems</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🏡</div>
            <h3>Expand Your Empire</h3>
            <p>Build multiple greenhouses and manage your growing botanical business</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🌸</div>
            <h3>Discover Rare Plants</h3>
            <p>Unlock exotic species like Orchids, Venus Flytraps, and more as you progress</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">📅</div>
            <h3>Seasonal Challenges</h3>
            <p>Adapt to changing seasons with unique effects on your plants throughout the year</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Quests & Achievements</h3>
            <p>Complete daily and weekly quests, unlock achievements, and fill your Plant Codex</p>
          </div>
        </div>
      </section>

      {/* Screenshots Section */}
      <section className="screenshots">
        <h2>Screenshots</h2>
        <div className="screenshots-grid">
          <div className="screenshot-item">
            <img src="/screenshots/greenhouse.png" alt="Greenhouse view" />
            <p>Manage your greenhouses and watch your plants grow</p>
          </div>
          <div className="screenshot-item">
            <img src="/screenshots/shop.png" alt="Shop" />
            <p>Unlock new seeds and expand your collection</p>
          </div>
          <div className="screenshot-item">
            <img src="/screenshots/quests.png" alt="Quests" />
            <p>Complete quests and earn rewards</p>
          </div>
          <div className="screenshot-item">
            <img src="/screenshots/upgrades.png" alt="Upgrades" />
            <p>Automate with powerful greenhouse upgrades</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <h2>Ready to Start Growing?</h2>
        <button className="play-button-large" onClick={() => navigate('/game')}>
          🌿 Play Sprout & Bloom Now
        </button>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© 2026 Sprout & Bloom | Made with 💚 for plant lovers</p>
      </footer>
    </div>
  );
}

export default LandingPage;